export default {
  nomeOriginal: {
    value: null,
    state: null,
    required: false
  },
  dataEnvio: {
    value: null,
    state: null,
    required: false
  }
}



// WEBPACK FOOTER //
// ./src/views/private/attachments/components/search/search-form.js